import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import BasePageView from '../sharedComponents/BasePageView/BasePageView';

export function HotelMapView(props) {
  const {
    siteContent: {
      data: { details: { hotelMapMCode, pageTitle } = {} },
    },
  } = props;
  const { t } = useTranslation();

  return (
    <BasePageView title={pageTitle || t('event.hotel-map')}>
      <div data-testid={hotelMapMCode ?? 'noHotelMapMCode'}>
        <script
          async
          src={`https://hotelmap.com/api/html/v2/listing?m=${hotelMapMCode}`}
          type="text/javascript"
          id="hotelmap_script"
        />
      </div>
    </BasePageView>
  );
}

function mapStateToProps(state) {
  return {
    siteContent: state.siteContent,
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(HotelMapView);
